import { render } from "./DiagramComponent.vue?vue&type=template&id=65302dff"
import script from "./DiagramComponent.vue?vue&type=script&lang=js"
export * from "./DiagramComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__